import { useState, useEffect, useRef } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Wallet, Loader2, Trash2 } from "lucide-react";
import POSHeader from "./POSHeader";

export default function PagamentosView({ authAxios, onBack }) {
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [payments, setPayments] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authAxiosRef.current.get("/pos/payments-today")
      .then(r => { setPayments(r.data.payments || []); setTotal(r.data.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatTime = (iso) => {
    if (!iso) return "";
    try {
      const d = new Date(iso);
      return d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
    } catch { return ""; }
  };

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex flex-col" data-testid="pos-pagamentos">
      <POSHeader title="Pagamentos" icon={Wallet} onBack={onBack} />

      {/* Summary */}
      <div className="bg-white border-b px-4 py-3 flex items-center justify-between">
        <span className="text-sm text-gray-500">Total do dia</span>
        <span className="text-xl font-black text-emerald-600">{total.toFixed(2)} EUR</span>
      </div>

      <ScrollArea className="flex-1">
        {loading ? (
          <div className="text-center py-12"><Loader2 className="w-6 h-6 animate-spin mx-auto text-emerald-600" /></div>
        ) : payments.length === 0 ? (
          <div className="text-center py-12 text-gray-400">
            <Wallet className="w-10 h-10 mx-auto mb-2 opacity-30" />
            <p className="text-sm">Nenhum pagamento hoje</p>
          </div>
        ) : (
          <div className="divide-y">
            {payments.map(p => (
              <div key={p.id} className="px-4 py-3 flex items-center gap-3 bg-white" data-testid={`payment-${p.id?.slice(0, 6)}`}>
                <span className="text-xs text-gray-400 w-12 flex-shrink-0">{formatTime(p.time)}</span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-700">{p.label}</p>
                </div>
                <button className="w-6 h-6 rounded bg-red-50 flex items-center justify-center flex-shrink-0">
                  <Trash2 className="w-3 h-3 text-red-400" />
                </button>
              </div>
            ))}
          </div>
        )}
      </ScrollArea>
    </div>
  );
}
